// import { canUseDOM } from 'exenv';

export function micYearDescriptionLoading(resp = {}, store = {}) {
  return {
    type: 'MIC_YEAR_DESCRIPTION_LOADING',
    micYearDescription: resp,
    store
  };
}

export function micYearDescriptionLoaded(resp = {}, store = {}) {
  return {
    type: 'MIC_YEAR_DESCRIPTION_LOADED',
    micYearDescription: resp,
    store
  };
}

export function micYearDescriptionLoadError(error, store = {}) {
  return {
    type: 'MIC_YEAR_DESCRIPTION_ERROR',
    micYearDescription: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
